// extracted by mini-css-extract-plugin
export default {"checkbox":"myCheckBox_checkbox__WgorJ"};